"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _infoTooltip = _interopRequireDefault(require("./info-tooltip"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const TitleWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleWrapper",
  class: "pl-t108305x"
});
const TitleText = /*#__PURE__*/(0, _react2.styled)("h2")({
  name: "TitleText",
  class: "pl-t17lnywf"
});
const Title = ({
  title,
  tooltipTitle,
  tooltipMessage
}) => /*#__PURE__*/_react.default.createElement(TitleWrapper, null, /*#__PURE__*/_react.default.createElement(TitleText, null, title), /*#__PURE__*/_react.default.createElement(_infoTooltip.default, {
  title: tooltipTitle,
  message: tooltipMessage
}));
Title.propTypes = {
  title: _propTypes.default.string,
  tooltipTitle: _propTypes.default.string,
  tooltipMessage: _propTypes.default.string
};
var _default = exports.default = Title;